export const goalMapping = {
  LOSE_WEIGHT: "Lose weight",
  BUILD_MUSCLE: "Build muscle",
  IMPROVE_FLEXIBILITY: "Flexibility",
  IMPROVE_MENTAL_HEALTH: "Reduce stress",
  IMPROVE_ENDURANCE: "Endurance",
};
